import Sdata from '@/database/sdata'

let g_entity = 'member_dpo'
let g_url    = 'studio/dpo'
let g_pkey   = ['uid']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Dpo extends Sdata
{
  static entity = g_entity
  static url    = g_url
}